import debounce from 'lodash-es/debounce';
import dispatchCustomEvent from '../../utils/dispatch-custom-event';

const AUTO_SUBMIT_DELAY = 500;
const FILTERS_CHANGED_EVENT = 'filters-changed';
const FILTERS_RESET_EVENT = 'filters-reset';

class TurbomapFilters {
	// `el` should be a form
	constructor(el) {
		this.el = el;

		this.autoSubmitForm = this.autoSubmitForm.bind(this);
		this.autoSubmitFormDebounced = debounce(this.autoSubmitForm, AUTO_SUBMIT_DELAY);

		this.el.addEventListener('reset', e => this.onReset(e));
		this.el.addEventListener('submit', e => this.onSubmit(e));
		this.el.addEventListener('change', this.autoSubmitFormDebounced);
		this.el.addEventListener('input', this.autoSubmitFormDebounced);
	}

	onReset(e) {
		e.preventDefault();

		dispatchCustomEvent(this.el, FILTERS_RESET_EVENT);
	}

	onSubmit(e) {
		e.preventDefault();

		this.dispatchCustomSubmit();
	}

	autoSubmitForm() {
		this.dispatchCustomSubmit();
	}

	dispatchCustomSubmit(e) {
		if (e) {
			e.preventDefault();
		}

		dispatchCustomEvent(this.el, FILTERS_CHANGED_EVENT);
	}

	set(filterValues = {}) {
		this.setUnderlying(filterValues);
		this.setLeverage(filterValues);
		this.setMaturity(filterValues);
		this.setDirection(filterValues);
		this.setStoploss(filterValues);
	}

	setUnderlying({ underlyingId }) {
		const underlying = this.el.querySelector('.js-underlying');

		underlying.value = underlyingId;
	}

	setLeverage({ leverageFrom = '', leverageTo = '' }) {
		const from = this.el.querySelector('.js-leverage-from');
		const to = this.el.querySelector('.js-leverage-to');

		if (!from || !to) {
			return;
		}

		from.value = leverageFrom;
		to.value = leverageTo;
	}

	setStoploss({ stoplossFrom = '', stoplossTo = '' }) {
		// these filters are only present on the turbomap, not on the warrantmap
		const from = this.el.querySelector('.js-stoploss-from');
		const to = this.el.querySelector('.js-stoploss-to');

		if (!from || !to) {
			return;
		}

		from.value = stoplossFrom;
		to.value = stoplossTo;
	}

	setMaturity({ timeToMaturity = '0' }) {
		const maturity = this.el.querySelector('.js-maturity');

		maturity.value = timeToMaturity;
	}

	setDirection({ direction = '' }) {
		// radio buttons
		Array.from(this.el.querySelectorAll('[name=direction]')).forEach((el) => {
			el.checked = el.value === direction;
		});
	}

	getFilterValues() {
		const formData = new FormData(this.el);
		const appliedFilters = {};

		formData.forEach((value, key) => {
			appliedFilters[key] = value;
		});

		return appliedFilters;
	}
}

export default TurbomapFilters;

export {
	FILTERS_CHANGED_EVENT,
	FILTERS_RESET_EVENT,
};
